import { render, staticRenderFns } from "./regno.vue?vue&type=template&id=49b1ba07&"
import script from "./regno.vue?vue&type=script&lang=js&"
export * from "./regno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports